import {
  FormWorkflowListItemDTO,
  FormWorkflowPaginatedCollectionDTO,
  PatientDTO,
  UserDTO,
} from 'dtos';
import isNil from 'lodash/isNil';
import {
  isNilOrZero,
} from '@populateui/utils';
import {
  FormWorkflowRow,
  NormalizeFormWorkflowsParams,
} from 'pages/Dashboard/pages/Forms/pages/FormWorkflow/types';
import {
  Patient,
} from 'pages/Dashboard/types/patient';
import {
  UserCompact,
} from 'types/user';
import {
  formatDateTime,
} from 'utils/date';
import {
  getDisplayName,
} from 'pages/Dashboard/utils/helper';

function normalizePatient(patient?: PatientDTO): Patient | undefined {
  if (isNil(patient)) {
    return undefined;
  }

  return {
    ...patient,
    formattedNames: patient.formattedNames ?? {},
  } as Patient;
}

function normalizeUser(user?: UserDTO): UserCompact | undefined {
  return isNil(user)
    ? undefined
    : {
      ...user,
      id: user.userId ?? 0,
      fullName: getDisplayName(user.formattedNames),
      image: null,
      formattedNames: user.formattedNames ?? {},
    } as UserCompact;
}

export function normalizeFormWorkflowRow(
  workflow: FormWorkflowListItemDTO,
  patients: Record<string, PatientDTO> = {},
  users: Record<string, UserDTO> = {},
): FormWorkflowRow {
  const patientId = workflow.patientId ?? 0;
  const initiatedByUserId = workflow.initiatedByUserId ?? 0;
  const { assignedClinicianUserId } = workflow;

  return {
    ...workflow,
    formattedCreatedOn: formatDateTime(workflow.createdOn ?? ''),
    patient: normalizePatient(patients[patientId]),
    initiatedByUser: normalizeUser(users[initiatedByUserId]),
    assignedClinicianUser: !isNilOrZero(assignedClinicianUserId)
      ? normalizeUser(users[assignedClinicianUserId as number])
      : undefined,
  };
}

export function normalizeFormWorkflows({
  response,
}: NormalizeFormWorkflowsParams): FormWorkflowRow[] {
  const patients = response.patients ?? {};
  const users = response.users ?? {};

  return response.formWorkflows?.data?.map((workflow) => (
    normalizeFormWorkflowRow(workflow, patients, users)
  )) ?? [];
}

export type { FormWorkflowPaginatedCollectionDTO };
